import { Card, CardContent, FormControl } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { OSLOBODJEN_OD_IZVJESCIVANJA, TIP_IZVJESCA } from "../../../../enums";
import { useEffect } from "react";

type Drzava = {
  naziv?: string;
  oznaka: string;
  euSifra: string;
};
const Index = () => {
  const { register, getValues, watch, setValue } = useFormContext();
  const oslobodjenOdIzvjescivanja = watch("oslobodjenOdIzvjescivanja");
  const postojiOslobodjenje = watch("postojiOslobodjenje");
  const tipIzvjesca = watch("tipIzvjesca");
  const drzaveEuTemp = watch("drzaveEuTemp");

  useEffect(() => {
    if (tipIzvjesca == TIP_IZVJESCA.IZ_RH) {
      setValue("drzavaIzvjestavanja.oznaka", "HR");
      setValue("drzavaIzvjestavanja.euSifra", "HR");
      setValue(
        "drzaveEu",
        [
          ...drzaveEuTemp,
          { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
        ].sort((a: Drzava, b: Drzava) => a.oznaka.localeCompare(b.oznaka))
      );
    } else {
      // @ts-ignore
      setValue(
        "drzaveEu",
        [...drzaveEuTemp].sort((a: Drzava, b: Drzava) =>
          a.oznaka.localeCompare(b.oznaka)
        )
      );
      setValue("drzavaIzdavatelj", {});
      setValue("drzavaIzvjestavanja", {});
    }
  }, [tipIzvjesca]);

  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardContent>
        <FormControl variant="standard" style={{ flexDirection: "row" }}>
          <h5 style={{ marginRight: 12 }}>
            Oslobođen od izvješćivanja: (Exempted from reporting:)
          </h5>
          <label
            htmlFor="oslobodjenOdIzvjescaDa"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: 12,
            }}
          >
            <input
              type={"radio"}
              value={OSLOBODJEN_OD_IZVJESCIVANJA.DA}
              id={"oslobodjenOdIzvjescaDa"}
              disabled={postojiOslobodjenje}
              {...register("oslobodjenOdIzvjescivanja")}
              style={{ marginRight: 6 }}
            />
            Da
          </label>
          <label
            htmlFor="oslobodjenOdIzvjescaNe"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type={"radio"}
              value={OSLOBODJEN_OD_IZVJESCIVANJA.NE}
              id={"oslobodjenOdIzvjescaNe"}
              disabled={postojiOslobodjenje}
              {...register("oslobodjenOdIzvjescivanja")}
              style={{ marginRight: 6 }}
            />
            Ne
          </label>
        </FormControl>
        {oslobodjenOdIzvjescivanja == OSLOBODJEN_OD_IZVJESCIVANJA.DA && (
          <div>
            <FormControl variant="standard">
              <div>
                <label
                  htmlFor="tipIzvjescaIzvanRh"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <input
                    type={"radio"}
                    value={TIP_IZVJESCA.IZVAN_RH.toString()}
                    id={"tipIzvjescaIzvanRh"}
                    disabled={postojiOslobodjenje}
                    {...register("tipIzvjesca")}
                    style={{ marginRight: 6 }}
                  />
                  Izvješće je podneseno u drugoj državi članici
                </label>
              </div>
              <div>
                <label
                  htmlFor="tipIzvjescaIzRh"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type={"radio"}
                    value={TIP_IZVJESCA.IZ_RH.toString()}
                    id={"tipIzvjescaIzRh"}
                    disabled={postojiOslobodjenje}
                    {...register("tipIzvjesca")}
                    style={{ marginRight: 6 }}
                  />
                  Izvješće je dostavio drugi operater platforme koji izvješćuje
                  u HR
                </label>
              </div>
            </FormControl>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Index;
